import {
  RyeMainContentCardHeader,
  RyeMainContentCardHeaderProps,
} from "./RyeMainContentCardHeader";
import { RyeMainContentContainerBase } from "./RyeMainContentContainerBase";

export function RyeMainContentCard({
  children,
  flexGrow = true,
  flexShrink = true,
  roundedTl = true,
  roundedTr = true,
  roundedBr = true,
  roundedBl = true,
  padTop = true,
  padBottom = true,
  header,
  belowHeader,
}: {
  children: React.ReactNode;
  flexGrow?: boolean;
  flexShrink?: boolean;
  roundedTl?: boolean;
  roundedTr?: boolean;
  roundedBr?: boolean;
  roundedBl?: boolean;
  padTop?: boolean;
  padBottom?: boolean;
  /** A standardized title row that stays outside the scrolling body. */
  header?: RyeMainContentCardHeaderProps;
  /** More content that stays outside the scrolling body, below the header. */
  belowHeader?: React.ReactNode;
}): JSX.Element {
  return (
    <RyeMainContentContainerBase
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      roundedTl={roundedTl}
      roundedTr={roundedTr}
      roundedBr={roundedBr}
      roundedBl={roundedBl}
      padTop={padTop}
      padBottom={padBottom}
      fixedHeader={
        header || belowHeader ? (
          <>
            {header && <RyeMainContentCardHeader {...header} />}
            {belowHeader}
          </>
        ) : undefined
      }
    >
      {children}
    </RyeMainContentContainerBase>
  );
}
